import { combineReducers } from 'redux';
import jobInvocations from './jobInvocations/';

export default combineReducers({
  jobInvocations,
});



// WEBPACK FOOTER //
// ./vendor/ruby/2.7.0/gems/foreman_remote_execution-10.1.1/webpack/react_app/redux/reducers/index.js